import React, { useRef } from "react";

const Payment = () => {
     const sectionRef = useRef(null);
    
      const handleClickNavigate = () => {
        // Scroll to the section smoothly
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
      };
    return(
        <div ref={sectionRef} class="pricing-container">
        <h1 className="text-black font-mono text-center text-xl sm:text-3xl" >Pick your perfect plan</h1>
        <p>Get started in complete confidence. Our 01-day money-back guarantee means it's risk-free.</p>
        <div class="pricing-plans">

            <div class="pricing-card">
                <h2>Half Tiffin</h2>
                <p>A great Tiffin Service</p>
                <div class="discount">17% OFF</div>
                <div class="price"><span>₹ 2400.00</span> ₹ 2100.00/mo</div>
                <a href="https://play.google.com/store/apps/details?id=com.dabbavala" target="blank" class="btn-Get">Get Membership</a>
                <p>2 roti</p>
                <p>Seasonal veg</p>
                <p>Rice</p>
                <p>Dal</p>
                <p>Salad/Achar/Chutney</p>
            </div>
            <div class="pricing-card popular">
                <h2>Full Tiffin</h2>
                <p>A great Tiffin Service</p>
                <div class="discount">17% OFF</div>
                <div class="price"><span>₹ 3000.00</span> ₹ 2700.00/mo</div>
                <a href="https://play.google.com/store/apps/details?id=com.dabbavala" target="blank" class="btn-Get">Get Membership</a>
                <p>2 roti</p>
                <p>Seasonal veg</p>
                <p>Rice</p>
                <p>Dal</p>
                <p>Salad/Achar/Chutney</p>
            </div>
           
            {/* <div class="pricing-card">
                <h2>EXECUTIVE</h2>
                <p>Level up with more power and enhanced features.</p>
                <div class="discount">70% OFF</div>
                <div class="price"><span>₹ 4000.00</span> ₹ 3500.00/mo</div>
                <a href="#" class="btn-Get">Get Membership</a>
                <p>1 Salad/Soup/Raita</p>
                <p>4 Chapatis</p>
                <p>2 Vegetable</p>
                <p>1 Dal</p>
                <p>1 Rice(Brown/White)</p>
                <p>1 Probiotic (Buttermilk/Curd)</p>
            </div> */}
           
        </div>
    </div>
    )
}

export default Payment;